import {
  internalCancellationInstant,
  parseSupplierCancellationInstant,
} from "./hubwayzCancellationDisplay";

/**
 * Hotel continuation does not ask for a flight deal.
 * A flight+hotel package still requires the live flight slice.
 */
export function passengerContinueGate({ hotelsOnly = false, rawDeal = null, source = null } = {}) {
  if (hotelsOnly) {
    return {
      ok: true,
      needsFlightProposal: false,
      ldsProposal: { ok: true, skipped: true, mode: "hotels_only_no_lds" },
    };
  }
  if (!rawDeal && source === "live") {
    return {
      ok: false,
      needsFlightProposal: false,
      error: "חסר rawDeal לטיסה — בחרו טיסה מחדש",
    };
  }
  return { ok: true, needsFlightProposal: true, ldsProposal: null };
}

function nonRefundable(type) {
  const value = String(type || "").toLowerCase();
  return value.includes("non") && value.includes("refund");
}

/**
 * Supplier free-cancel window whose internal deadline is still ahead.
 * A past deadline or a non-refundable offer does not allow deferred payment.
 */
export function hotelFutureCxlAllowsDeferredPayment(normalized, now = new Date()) {
  if (!normalized?.supplierConfirmed) return false;
  const cancellation = normalized.display?.cancellation;
  if (nonRefundable(cancellation?.type)) return false;
  const frames = Array.isArray(cancellation?.frames) ? cancellation.frames : [];
  const nowMs = now instanceof Date ? now.getTime() : new Date(now).getTime();
  if (!Number.isFinite(nowMs)) return false;
  return frames.some((frame) => {
    const amount = Number(frame?.penalty?.amount);
    if (amount !== 0) return false;
    const parsed = parseSupplierCancellationInstant(frame?.to);
    if (!parsed) return false;
    return internalCancellationInstant(parsed.instant).getTime() > nowMs;
  });
}

/**
 * Deferred payment is offered only when the verified quote, a future supplier
 * CXL, and the system hotel-prebooking gate all agree. Missing any one hides it.
 */
export function hotelDeferredPaymentAvailable({
  normalized = null,
  quote = null,
  systemAllowed = false,
  now = new Date(),
} = {}) {
  if (systemAllowed !== true) return false;
  if (!quote || quote.source !== "server_quote" || quote.binding !== true) return false;
  return hotelFutureCxlAllowsDeferredPayment(normalized, now);
}
